// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioFilledSvg from "@fishx/icons-svg/es/asn/AudioFilled";
import FishxIcon from '../components/FishxIcon';

var AudioFilled = function AudioFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioFilledSvg
  }));
};

AudioFilled.displayName = 'AudioFilled';
export default React.forwardRef(AudioFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AudioFilled.js
// module id = 2025
// module chunks = 0